import m from "./../../../dist/es2015/themes/Animated.js";
export const am5themes_Animated = m;